import React, { useEffect } from 'react'
import { CreditApplication, StatusCategory } from '_gql'

import { FormattedMessage } from '@divvy-web/i18n'
import { BannerType } from '@divvy-web/skylab.banner'

import useGetCreditAppTypes from '@sputnik/hooks/useGetCreditAppTypes'
import StatusBanner from '@sputnik/pages/DashboardPages/CreditApplicationsDataGrid/DashboardDetailsDrawer/ApplicationDetailsTabContent/ActionsNeededSection/StatusBanner'
import { useWebTracking } from '@sputnik/tracking/WebTrackingContext'

interface OfferAcceptedBannerProps {
  salesforceCreditId: string
  statusCategory: CreditApplication['statusCategory']
}

/* This will show if decisions?.length > 0 && hasSelectedDecision && compliance is still in review */
const OfferAcceptedBanner = ({ salesforceCreditId, statusCategory }: OfferAcceptedBannerProps) => {
  const { isMigration, isLoadingCreditAppTypes } = useGetCreditAppTypes({ salesforceCreditId })

  const { track } = useWebTracking()
  useEffect(() => {
    if (isLoadingCreditAppTypes) {
      return
    }

    track('se_signup__application_dashboard_action_needed_offer_accepted__presented', {
      is_migration: isMigration,
    })
  }, [isLoadingCreditAppTypes, isMigration, track])

  const getSubtext = () => {
    if (statusCategory === StatusCategory.IN_REVIEW) {
      return (
        <FormattedMessage
          defaultMessage='We’ll verify your identity and get in touch about next steps within 3-5 days.'
          id='sputnik.OfferAcceptedBanner__dezVS5'
        />
      )
    } else {
      return (
        <FormattedMessage
          defaultMessage='Review any action items above to finish your application.'
          id='sputnik.OfferAcceptedBanner__9o5LMu'
        />
      )
    }
  }

  return (
    <div className='fs-unmask'>
      <StatusBanner
        bannerType={BannerType.Success}
        subtext={getSubtext()}
        title={
          <FormattedMessage
            defaultMessage='Offer accepted'
            id='sputnik.OfferAcceptedBanner__1JRfgv'
          />
        }
      />
    </div>
  )
}

export default OfferAcceptedBanner
